import { generateFormData } from '@/helpers/formDataHelper';
import axiosApi from '@/plugins/axios/configApi';

export default {
  // addCode(...payload) {
  //   return axiosV1.post('products/pins', ...payload)
  // },
  
  // FETCH
  getServiceCenter(id=null) {
    return axiosApi.get(`service-center/${id}`)
  },

  getServiceCenters(params) {
    return axiosApi.get(`service-center`, { params }); 
  },

  
  // EXPORT
  async exportServiceCenters(params) {
    return axiosApi.get(`service-center/export/data`, { params });
  },

  async getProductVerification(params) {
    // return axiosV1.get(`products/pins`, { params });
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    return Promise.resolve({
      data: {
        product: {
          total: 10,
          last_page: 20,
          data: [
            { id: 1, request_no: 'RN-7389494', date_registered: 'Oct 20, 2022', product_category: 'Hardware', sub_category: 'Photography', serial_no: '9309484804', campaign: 'Summer Promo', rewards: 'Points and Extended Warranty', points_to_earn: 4000 },
            { id: 1, request_no: 'RN-7389494', date_registered: 'Oct 20, 2022', product_category: 'Hardware', sub_category: 'Photography', serial_no: '9309484804', campaign: 'Summer Promo', rewards: 'Extended Warranty', points_to_earn: null },
            { id: 1, request_no: 'RN-7389494', date_registered: 'Oct 20, 2022', product_category: 'Hardware', sub_category: 'Photography', serial_no: '9309484804', campaign: 'Summer Promo', rewards: 'Extended Warranty', points_to_earn: null },
          ]
        }
      }
    }) 
  },

  // UPDATE
  updateServiceCenter(id=null, payload) {
    axiosApi.defaults.headers.common["Content-Type"] = "multipart/form-data";
    
    const formData = generateFormData(payload)
    return axiosApi.post(`service-center/${id}`, formData)
  },

  // DELETE
  deleteServiceCenter(id=null) {
    return axiosApi.post(`service-center/delete/${id}`)
  },
  deleteServiceCenters(ids=null) {
    return axiosApi.post(`service-center/centers/delete`, { center_id: ids })
  },
  // HARD DELETE
  hardDeleteServiceCenter(id=null) {
    return axiosApi.post(`service-center/delete/${id}`, { force_delete: '1' })
  },
  hardDeleteServiceCenters(ids=null) {
    return axiosApi.post(`service-center/centers/delete/force`, { center_id: ids })
  },
  
  // RECOVER
  recoverServiceCenter(id=null) {
    return axiosApi.put(`service-center/trashed/restore/${id}`)
  },
  recoverServiceCenters(ids=null) {
    return axiosApi.post(`service-center/trashed/restore/centers`, { center_id: ids })
  }, 
  
  // IMPORT
  importServiceCenter(file=null) {
    let formData = new FormData();
    formData.append('file', file);
    axiosApi.defaults.headers.common['Content-Type'] = 'multipart/form-data'
    return axiosApi.post(`service-center/import/centers`, formData)
  },
};
